function parseMaxEmpiricalParticipants(): number | null {
  const raw = process.env.REACT_APP_MAX_EMPIRICAL_PARTICIPANTS;
  if (raw == null || String(raw).trim() === '') return null;
  const n = Number(raw);
  if (!Number.isFinite(n) || n < 1) return null;
  return Math.floor(n);
}

// Конфигурация API
export const API_CONFIG = {
  BASE_URL: process.env.REACT_APP_BASE_URL || '/api',
  SOCKET_URL: process.env.REACT_APP_SOCKET_URL || '/',
  TELEGRAM_USERNAME:
    process.env.REACT_APP_TELEGRAM_USERNAME ||
    (process.env.REACT_APP_EDITION === 'checks' ? '' : 'rich_test_pm_bot'),

  MAX_EMPIRICAL_PARTICIPANTS: parseMaxEmpiricalParticipants(),

  // Яндекс OAuth настройки
  YANDEX_CLIENT_ID: process.env.REACT_APP_YANDEX_CLIENT_ID || '',
  YANDEX_REDIRECT_URI: process.env.REACT_APP_YANDEX_REDIRECT_URI || `${window.location.origin}/auth/yandex/callback`,

  /** Ключ клиента Yandex SmartCaptcha (публичный). Без ключа капча отключена. */
  SMARTCAPTCHA_SITE_KEY: process.env.REACT_APP_SMARTCAPTCHA_SITE_KEY || '',

  ENDPOINTS: {
    AUTH: {
      LOGIN: '/auth/login',
      VERIFY: '/auth/verify',
      REFRESH: '/auth/refresh',
      LOGOUT: '/auth/logout',
      YANDEX_TOKEN: '/auth/yandex/token',
      TELEGRAM: '/auth/telegram',
      TELEGRAM_BOT_ID: '/auth/telegram/bot-id',
      REFERRAL_VISIT: '/auth/referral/visit',
      LOCAL_REGISTER: '/auth/local/register',
      LOCAL_LOGIN: '/auth/local/login',
      LOCAL_VERIFY_EMAIL: '/auth/local/verify-email',
      LOCAL_RESEND_VERIFICATION: '/auth/local/resend-verification',
      LOCAL_FORGOT_PASSWORD: '/auth/local/forgot-password',
      LOCAL_RESET_PASSWORD_VALIDATE: '/auth/local/reset-password/validate',
      LOCAL_RESET_PASSWORD: '/auth/local/reset-password',
    },
    // Работа с документами — только в основной сборке (см. src/index.tsx)
    FILES:
      process.env.REACT_APP_EDITION === 'checks'
        ? ({} as Record<'UPLOAD' | 'PARSE' | 'PARSED' | 'PARAPHRASE', string>)
        : {
            UPLOAD: '/files/upload',
            PARSE: '/files/parse',
            PARSED: '/files/parsed',
            PARAPHRASE: '/files/paraphrase',
          },
    API: {
      DOCUMENTS: '/api/documents',
      UPDATE_HANDLE: '/api/update-handle',
      BUILD: '/api/build',
      IMAGE: '/api/image',
      CONSENT: '/api/consent',
    },
  },
};


// Вспомогательная функция для создания полного URL
export function createApiUrl(endpoint: string): string {
  // Если endpoint уже содержит полный URL, возвращаем как есть
  if (endpoint.startsWith('http://') || endpoint.startsWith('https://')) {
    return endpoint;
  }
  
  // Убеждаемся что endpoint начинается с /
  const normalizedEndpoint = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
  
  return `${API_CONFIG.BASE_URL}${normalizedEndpoint}`;
}
